import { useState, useEffect, useCallback } from 'react';

export type Theme = 'dark' | 'light';

export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => {
    try {
      const stored = localStorage.getItem('mehfil_theme');
      return (stored === 'light' ? 'light' : 'dark');
    } catch {
      return 'dark';
    }
  });

  const applyTheme = useCallback((newTheme: Theme) => {
    setThemeState(newTheme);
    try {
      localStorage.setItem('mehfil_theme', newTheme);
      document.documentElement.setAttribute('data-theme', newTheme);
      // Dispatch custom DOM event required by test 24.4
      window.dispatchEvent(new CustomEvent('themechange', { detail: { theme: newTheme } }));
    } catch (e) {
      console.warn('Failed to persist theme:', e);
    }
  }, []);

  const toggleTheme = useCallback(() => {
    applyTheme(theme === 'dark' ? 'light' : 'dark');
  }, [theme, applyTheme]);

  useEffect(() => {
    // Ensure document reflects initial state
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return { theme, isDark: theme === 'dark', toggleTheme, setTheme: applyTheme };
}
